// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commit-title {
    line-height: 40px;
}

.commit-files {
}

.git-container {
    display: grid;
    grid-template-columns: 300px auto;
    grid-template-rows: 75px auto;
    height: 100%;
    width: 100%;
    overflow: hidden;
}

.git-action-bar {
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    flex-direction: row;
    align-items:center;
}

.git-action-bar-button {
    margin: 0;
    min-width: 75px;
    color:var(--text-color);
}
.git-action-bar-button:hover {
    background: var(--primary-color);
    color: var(--text-hover-color);
}
.git-action-bar-button-icon {
    height: 32px;
    width: 32px;
}
.git-action-bar-button-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    line-height:24px;
}

.git-workspace {
    grid-row-start: 2;
    grid-row-end: 2;
    grid-column-start: 1;
    grid-column-end: 1;
}

.git-content {
    grid-row-start: 2;
    grid-row-end: 2;
    grid-column-start: 2;
    grid-column-end: 3;
    overflow: hidden;
}

.git-commit-panel {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 50px 1fr 50px 1fr 100px;
    overflow: hidden;
    height: calc(100% - 50px);
}

.stagedfiles-header {
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.stagedfiles {
    grid-row-start: 2;
    grid-row-end: 2;
    grid-column-start: 1;
    grid-column-end: 1;
    overflow: auto;
}
.unstagedfiles {
    grid-row-start: 4;
    grid-row-end: 4;
    grid-column-start: 1;
    grid-column-end: 1;
    overflow: auto;
}
.unstagedfiles-header {
    grid-row-start: 3;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.commit-comment-container {
    grid-row-start: 5;
    grid-row-end: 5;
    grid-column-start: 1;
    grid-column-end: 3;
    display:grid;
    grid-template-rows: 1fr 45px;
}
.commit-actions {
    display:flex;
    flex-direction:row;
    width:100%;
    align-items:center;
}
.commit-file {
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
}
.commit-file:hover {
    background: var(--primary-color);
    color: var(--text-hover-color);
}
.commit-file-selected {
    background: var(--primary-color);
    color: var(--text-hover-color);
}
.commit-diff-container {
    grid-row-start: 1;
    grid-row-end: 5;
    grid-column-start: 2;
    grid-column-end: 2;
    overflow: auto;
}
.side-by-side-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 70px 1fr;
    z-index:10;
    background:white;
}
.side-by-side-overlay-old {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 2;
}
.side-by-side-overlay-new {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 2;
    grid-column-end: 3;
}
.side-by-side-overlay-close {
    position:absolute;
    top:5px;
    right:5px;
    z-index:2;
}
.file-selection-box {
    padding-left:5px;
    padding-right:10px;
}

.full-graph { 
    grid-row-start:1;
    grid-row-end:3;
    grid-column-start:1;
    grid-column-end:3;
    overflow:auto;
}
.selected-graph {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 1;
    grid-column-end: 2;
    overflow:auto;
}
.git-activity-files {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 2;
    overflow:auto;
}
.git-activity-diff {
    grid-row-start: 1;
    grid-row-end: 3;
    grid-column-start: 2;
    grid-column-end: 3;
    overflow:hidden;
}
.git-acitvity-container {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 2fr 1fr;
    display: grid;
    height: calc(100% - 50px);
    overflow: hidden;
}

.comparison-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 70px 1fr;
    z-index: 10;
    background: white;
}
.comparison-diff {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 2;
}
.comparison-close {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
}
.comparison-item-create {
    background: green;
}
.comparison-item-remove{
    background: red;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/development/git/git.settings.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;AACA;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;IAC3C,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;AACA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,4BAA4B;IAC5B,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,OAAO;IACP,SAAS;IACT,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB","sourcesContent":[".commit-title {\n    line-height: 40px;\n}\n\n.commit-files {\n}\n\n.git-container {\n    display: grid;\n    grid-template-columns: 300px auto;\n    grid-template-rows: 75px auto;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n}\n\n.git-action-bar {\n    grid-row-start: 1;\n    grid-row-end: 1;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    display: flex;\n    flex-direction: row;\n    align-items:center;\n}\n\n.git-action-bar-button {\n    margin: 0;\n    min-width: 75px;\n    color:var(--text-color);\n}\n.git-action-bar-button:hover {\n    background: var(--primary-color);\n    color: var(--text-hover-color);\n}\n.git-action-bar-button-icon {\n    height: 32px;\n    width: 32px;\n}\n.git-action-bar-button-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    line-height:24px;\n}\n\n.git-workspace {\n    grid-row-start: 2;\n    grid-row-end: 2;\n    grid-column-start: 1;\n    grid-column-end: 1;\n}\n\n.git-content {\n    grid-row-start: 2;\n    grid-row-end: 2;\n    grid-column-start: 2;\n    grid-column-end: 3;\n    overflow: hidden;\n}\n\n.git-commit-panel {\n    display: grid;\n    grid-template-columns: 50% 50%;\n    grid-template-rows: 50px 1fr 50px 1fr 100px;\n    overflow: hidden;\n    height: calc(100% - 50px);\n}\n\n.stagedfiles-header {\n    grid-row-start: 1;\n    grid-row-end: 1;\n    grid-column-start: 1;\n    grid-column-end: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n.stagedfiles {\n    grid-row-start: 2;\n    grid-row-end: 2;\n    grid-column-start: 1;\n    grid-column-end: 1;\n    overflow: auto;\n}\n.unstagedfiles {\n    grid-row-start: 4;\n    grid-row-end: 4;\n    grid-column-start: 1;\n    grid-column-end: 1;\n    overflow: auto;\n}\n.unstagedfiles-header {\n    grid-row-start: 3;\n    grid-row-end: 3;\n    grid-column-start: 1;\n    grid-column-end: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n.commit-comment-container {\n    grid-row-start: 5;\n    grid-row-end: 5;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    display:grid;\n    grid-template-rows: 1fr 45px;\n}\n.commit-actions {\n    display:flex;\n    flex-direction:row;\n    width:100%;\n    align-items:center;\n}\n.commit-file {\n    height: 40px;\n    line-height: 40px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n}\n.commit-file:hover {\n    background: var(--primary-color);\n    color: var(--text-hover-color);\n}\n.commit-file-selected {\n    background: var(--primary-color);\n    color: var(--text-hover-color);\n}\n.commit-diff-container {\n    grid-row-start: 1;\n    grid-row-end: 5;\n    grid-column-start: 2;\n    grid-column-end: 2;\n    overflow: auto;\n}\n.side-by-side-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 70px 1fr;\n    z-index:10;\n    background:white;\n}\n.side-by-side-overlay-old {\n    grid-row-start: 2;\n    grid-row-end: 3;\n    grid-column-start: 1;\n    grid-column-end: 2;\n}\n.side-by-side-overlay-new {\n    grid-row-start: 2;\n    grid-row-end: 3;\n    grid-column-start: 2;\n    grid-column-end: 3;\n}\n.side-by-side-overlay-close {\n    position:absolute;\n    top:5px;\n    right:5px;\n    z-index:2;\n}\n.file-selection-box {\n    padding-left:5px;\n    padding-right:10px;\n}\n\n.full-graph { \n    grid-row-start:1;\n    grid-row-end:3;\n    grid-column-start:1;\n    grid-column-end:3;\n    overflow:auto;\n}\n.selected-graph {\n    grid-row-start: 1;\n    grid-row-end: 2;\n    grid-column-start: 1;\n    grid-column-end: 2;\n    overflow:auto;\n}\n.git-activity-files {\n    grid-row-start: 2;\n    grid-row-end: 3;\n    grid-column-start: 1;\n    grid-column-end: 2;\n    overflow:auto;\n}\n.git-activity-diff {\n    grid-row-start: 1;\n    grid-row-end: 3;\n    grid-column-start: 2;\n    grid-column-end: 3;\n    overflow:hidden;\n}\n.git-acitvity-container {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 2fr 1fr;\n    display: grid;\n    height: calc(100% - 50px);\n    overflow: hidden;\n}\n\n.comparison-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: 70px 1fr;\n    z-index: 10;\n    background: white;\n}\n.comparison-diff {\n    grid-row-start: 2;\n    grid-row-end: 3;\n    grid-column-start: 1;\n    grid-column-end: 2;\n}\n.comparison-close {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    z-index: 2;\n}\n.comparison-item-create {\n    background: green;\n}\n.comparison-item-remove{\n    background: red;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
